var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import queryString from 'query-string';
import store from 'app/configureStore';
import { beginInvitationAccept } from 'app/actions/sandboxItemActions';
import { showModal } from 'app/actions/modalActions';
import { getURLDesiredSandbox } from './globalHelpers';
var urlActionHelper = function (items, accessToken, remoteUseCases) {
    var itemToActOn = null;
    var hash = queryString.parse(window.location.search);
    if (!hash)
        return;
    var sandboxHashKey = hash.sandboxHashKey, usecase = hash.usecase;
    var action = hash.action;
    if (usecase) {
        action = 'usecase';
    }
    if (sandboxHashKey)
        itemToActOn = items.find(function (i) { return i.sandboxHashKey === sandboxHashKey; });
    switch (action) {
        case 'usecase': {
            var URLDesiredSandbox = getURLDesiredSandbox(remoteUseCases);
            if (URLDesiredSandbox) {
                store.dispatch(
                // @ts-ignore
                showModal({
                    type: 'urlDesiredModal',
                    data: { usecase: URLDesiredSandbox },
                }));
            }
            break;
        }
        case 'extend':
            if (!itemToActOn)
                return;
            if (itemToActOn.hasExtended !== true) {
                store.dispatch(
                // @ts-ignore
                showModal({
                    type: 'extend',
                    data: __assign(__assign({}, itemToActOn), { clickedFrom: 'emailAction' }),
                }));
            }
            break;
        case 'invitation-accept':
            if (hash.invitationCode) {
                // @ts-ignore
                store.dispatch(beginInvitationAccept(accessToken, hash.invitationCode));
            }
            break;
        case 'invite':
            if (!itemToActOn || itemToActOn.sbRel !== 'IS_ALLOCATED')
                return;
            if (hash.sandboxHashKey) {
                // @ts-ignore
                store.dispatch(showModal({ type: 'invite', data: __assign({}, itemToActOn) }));
            }
            break;
        case 'pushArua':
            if (!itemToActOn || itemToActOn.sbRel !== 'IS_ALLOCATED')
                return;
            if (hash.sandboxHashKey) {
                // @ts-ignore
                store.dispatch(showModal({ type: 'pushArua', data: __assign({}, itemToActOn) }));
            }
            break;
        default:
            if (items.length === 0) {
                // @ts-ignore
                store.dispatch(showModal({ type: 'create' }));
            }
            break;
    }
};
export default urlActionHelper;
